<template>
  <!-- LotTrace 통합 추적 View — SPEC-CHINA-LOT-BATCH-TRACEABILITY-001 REQ-FE-TRC-001~011a -->
  <!-- SPEC-CHINA-LOT-FLOW-DASHBOARD-001 REQ-FE-DETAIL-001a: FullPage wrapper (기존 동작 100% 보존) -->
  <div class="page-container-v2">
    <div class="page-header">
      <span class="page-title">{{ $t('lotTrace_title') }}</span>
      <span v-if="traceValue" class="lot-trace-value-badge">{{ traceValue }}</span>
      <!-- REQ-FE-TRC-007: refresh 버튼 -->
      <a-button
        style="margin-left: auto;"
        :loading="loading"
        @click="fetchTrace"
      >
        <template #icon><ReloadOutlined /></template>
        {{ $t('lotTrace_actions_refresh') }}
      </a-button>
    </div>

    <!-- LotTraceDetail 재사용 — REQ-FE-DETAIL-001a -->
    <!-- @MX:NOTE: [AUTO] REQ-COMPAT-102 — wrapper 리팩토링 후에도 기존 사용자 가시 동작 100% 보존 -->
    <lot-trace-detail
      :response="result"
      :loading="loading"
      :fetch-error="fetchError"
      :trace-value="traceValue"
      :show-full-page-link="false"
      @navigate="navigateTo"
      @retry="fetchTrace"
    />
  </div>
</template>

<script>
// @MX:ANCHOR: [AUTO] LotTrace 통합 추적 View — SPEC-CHINA-LOT-BATCH-TRACEABILITY-001 REQ-FE-TRC-001~011a
// @MX:REASON: [AUTO] 4개 화면 cross-link + GlobalLotSearchInput 모두 이 View를 단일 진입점으로 사용. fan_in >= 4
import lotTraceApi from '@/apis/lotTrace';
import LotTraceDetail from './LotTraceDetail.vue';
import { ReloadOutlined } from '@ant-design/icons-vue';

export default {
  name: 'LotTrace',
  components: { LotTraceDetail, ReloadOutlined },

  data() {
    return {
      loading: false,
      fetchError: null,
      result: null,
    };
  },

  computed: {
    // REQ-FE-TRC-002: path param value (decodeURIComponent는 router 자동)
    traceValue() {
      return this.$route.params.value || '';
    },
  },

  mounted() {
    // REQ-FE-TRC-002: mount 시 1회 fetch
    this.fetchTrace();
  },

  watch: {
    // route param 변경 시 재fetch (헤더 검색 등)
    '$route.params.value'() {
      this.fetchTrace();
    },
  },

  methods: {
    // @MX:WARN: [AUTO] lot-trace 비동기 fetch — 네트워크 오류/5xx 시 error banner + retry (REQ-FE-TRC-010a)
    // @MX:REASON: [AUTO] fetchError 미처리 시 사용자에게 빈 화면만 표시됨
    async fetchTrace() {
      const val = this.traceValue;
      if (!val) return;
      this.loading = true;
      this.fetchError = null;
      try {
        const res = await lotTraceApi.traceLot(val);
        this.result = res?.data || res || null;
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || String(err);
        this.fetchError = msg;
        this.result = null;
      } finally {
        this.loading = false;
      }
    },

    // 패널 deep-link / "전체 보기" 네비게이션 처리
    navigateTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.lot-trace-value-badge {
  font-size: 13px;
  background: #f0f2f5;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 2px 8px;
  margin-left: 12px;
  font-family: monospace;
}
/* REQ-FE-TRC-009: 모바일 375px 반응형 — 패널 stack은 기본 flex-direction:column으로 자동 충족 */
@media (max-width: 480px) {
  .lot-trace-value-badge {
    font-size: 11px;
  }
}
</style>
